<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AAPEK2/tc-custom/9781788853545.jpg?1696640483435" alt="This image is the cover for the book White Cockade"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">White Cockade
      </h1>
      <p class="bookDescription body article font2">
        <b>Stories that represent the hold that the Jacobites—and their resentment of British rule—still have in Scotland. An essential read for fans of <i>Outlander</i>.</b><br/><br/>During the first half of the eighteenth century, Bonnie Prince Charlie and his diehard supporters—the Jacobites—almost changed the course of British history. Their attempts to drive out the house of Hanover and restore the Stuarts to the British throne is one of the great epics of history. <br/><br/>In this book, acclaimed storyteller Stuart McHardy retells over forty Jacobite stories which date back to the time of the prince himself and his bitter defeat at the Battle of Culloden. Featuring the exploits of real people and actual events, and including tales of love, loyalty, bravery and treachery, <i>The White Cockade</i> opens a window into a remarkable world and features a huge cast of colorful characters.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stuart McHardy
      </h2>
      
      <p class="authorDescription body article">Stuart Mchardy is a writer, storyteller and lecturer. His interest in Scotland's past has led him to re-rvaluate the role of the oral tradition in gaining a clearer picture of our history. He believes that while history is written by winners, story flourishes amongst history's survivors. He was Director of the Scots Language Resource Centre from 1993 to 1998 and is a founding member and past President of the Pictish Arts Society. An experienced broadcaster, Stuart Mchardy has long been interested in Scotland's musical traditions, playing music professionally since his teens. He lives in Edinburgh.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Birlinn
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?775de374